/**
 * Pseudo-localization for layout testing: accented look-alikes, ~40% expansion and visible
 * brackets reveal untranslated strings, truncation and concatenation bugs. ICU syntax is
 * preserved: only text at even brace depth (top level and plural/select branches) changes;
 * argument names, types and `#` are kept.
 */
const ACCENTED = {
    a: 'á',
    e: 'é',
    i: 'í',
    o: 'ó',
    u: 'ú',
    c: 'ç',
    n: 'ñ',
    s: 'š',
    y: 'ý',
    z: 'ž',
    A: 'Á',
    E: 'É',
    I: 'Í',
    O: 'Ó',
    U: 'Ú',
    C: 'Ç',
    N: 'Ñ',
    S: 'Š',
    Y: 'Ý',
    Z: 'Ž',
};
export function pseudoLocalize(message) {
    let depth = 0;
    let letters = 0;
    let out = '';
    for (const char of message) {
        if (char === '{')
            depth += 1;
        if (char === '}')
            depth -= 1;
        const isText = depth % 2 === 0 && char !== '{' && char !== '}' && char !== '#';
        if (isText) {
            out += ACCENTED[char] ?? char;
            if (/\p{L}/u.test(char))
                letters += 1;
        }
        else {
            out += char;
        }
    }
    const padding = '~'.repeat(Math.ceil(letters * 0.4));
    return `⟦${out}${padding}⟧`;
}
//# sourceMappingURL=pseudo.js.map